import React from 'react';

import TextField from '@mui/material/TextField';

import PropTypes from 'prop-types';

const defaultDebounceTime = 1000; //1s

//TODO może kiedyś dodać jakieś filtry/walidację jak będzie potrzebne, zobaczymy jak filtry zostaną oficjalnie dodane


function DebouncedTextField({ value, setValue, label, debounceTime, ...props }) {

  const [debouncedValue, setDebouncedValue] = React.useState(typeof value === 'string' ? value : '');
  debounceTime = typeof debounceTime === 'number' ? debounceTime : defaultDebounceTime;

  React.useEffect(() => {
      const timeoutID = setTimeout(() => setValue(debouncedValue), debounceTime);
      return () => clearTimeout(timeoutID); //Deletes timeout when next useEffect triggers
    }, [debouncedValue, debounceTime, setValue]
  );

  return (
    <TextField
      fullWidth
      label={label}
      {...props}
      value={debouncedValue}
      onChange={evt => setDebouncedValue(evt.target.value)}
    >
      {props.children}
    </TextField>
  );
}

DebouncedTextField.propTypes = {
  ...TextField.propTypes,
  value:        PropTypes.string,
  setValue:     PropTypes.func.isRequired,
  label:        PropTypes.string.isRequired,
  debounceTime: PropTypes.number,
};

export default React.memo(DebouncedTextField);
